import React from 'react';

const If = props => {
  const { condition, children } = props;
  if (condition) {
    return <React.Fragment>{children}</React.Fragment>;
  }
  return <React.Fragment />;
};

export default If;
